import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import TmntText from '../../components/tmnt-text/tmnt-text';

export default function ActionButtons({
  confirmationDetails,
  returnedOrder,
  loadingFailure,
  onCancelClick,
  isCancelDisabled,
  isReadyToDisplay,
}) {
  const {
    hidePrintLabelBtn,
    isLabel,
    labelUrl,
    printLabelLoadingTmnt,
    printLabelReadyTmnt,
    orderHistoryUrl,
  } = confirmationDetails;

  const printLabelBtn = useMemo(() => {
    // Don't show the button if we're not ready to display, if it's hidden, or if it's not a label
    if (!isReadyToDisplay || hidePrintLabelBtn || !isLabel) {
      return null;
    }

    const isProcessing = !labelUrl && !loadingFailure;
    const isDisabled = !labelUrl || loadingFailure;
    const isReady = labelUrl || loadingFailure;

    return (
      <Button
        isDisabled={isDisabled}
        isProcessing={isProcessing}
        isFullWidth
        classList={`label-generation-button ${loadingFailure ? 'mt-1 button-disabled' : 'mt-5'}`}
        variant="secondary"
        href={labelUrl}
        target="_blank"
      >
        {isProcessing && <TmntText k={printLabelLoadingTmnt} />}
        {isReady && <TmntText k={printLabelReadyTmnt} />}
      </Button>
    );
  }, [
    loadingFailure,
    hidePrintLabelBtn,
    isLabel,
    labelUrl,
    printLabelLoadingTmnt,
    printLabelReadyTmnt,
    isReadyToDisplay,
  ]);

  return (
    <>
      {printLabelBtn}

      {(returnedOrder?.orderDetails
        && returnedOrder?.returnDetailsURL
      ) && (
        <Button
          isFullWidth
          classList="mt-2 return-details-button"
          variant={hidePrintLabelBtn ? 'secondary' : 'tertiary-dark'}
          href={returnedOrder.returnDetailsURL}
        >
          <TmntText k="DRE_RETURN_DETAILS" />
        </Button>
      )}

      <Button
        isFullWidth
        classList="dre-cancel-btn"
        variant="borderless"
        onClick={onCancelClick}
        isDisabled={isCancelDisabled}
      >
        <TmntText k="DRE_CANCEL_RETURN" />
      </Button>
    </>
  );
} 

ActionButtons.propTypes = {
  confirmationDetails: PropTypes.shape({
    hidePrintLabelBtn: PropTypes.bool.isRequired,
    isLabel: PropTypes.bool.isRequired,
    labelUrl: PropTypes.string,
    printLabelLoadingTmnt: PropTypes.string,
    printLabelReadyTmnt: PropTypes.string,
    orderHistoryUrl: PropTypes.string,
  }).isRequired,
  returnedOrder: PropTypes.shape({
    orderDetails: PropTypes.shape({
      email: PropTypes.string,
    }).isRequired,
    returnDetailsURL: PropTypes.string,
  }).isRequired,
  loadingFailure: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isCancelDisabled: PropTypes.bool.isRequired,
  isReadyToDisplay: PropTypes.bool.isRequired,
};